import { Component, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { DashboardService } from '../../services/dashboard.service';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-grade-match',
  templateUrl: './grade-match.component.html',
  styleUrl: './grade-match.component.scss'
})
export class GradeMatchComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService) { }
  loading: boolean;
  chart: Chart<'doughnut', number[], unknown>;
  left: number;
  percentage: number;
  noData: boolean;
  html: string;
  matchedPercentage: string;
  alignPercentage: boolean;
  private unsubscribe$ = new Subject<void>()

  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.noData = !result.gradeMatchPct && !result.vehiclesGraded;
      if (result.gradeMatchPct >= 0 && result.vehiclesGraded > 0) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.createChart(result.gradeMatchPct);
        this.dashboardService.convertToPercentage(result.gradeMatchPct);
        this.left = 100 - this.percentage;
        this.alignPercentage = this.percentage < 100;
        this.matchedPercentage = `${this.percentage}%`;
        this.html = `<div>${result.gradeMatches}</div><hr class='hrStyle'><div>${result.vehiclesGraded}</div> `;
      } else if (!result.gradeMatchPct && !result.vehiclesGraded) {
        if (this.chart) {
          this.chart.destroy();
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  createChart(curGradeMatchPct) {
    const ctx = document.getElementById('gradeMatch') as HTMLCanvasElement;
    this.percentage = this.dashboardService.convertToPercentage(curGradeMatchPct);
    this.left = 100 - this.percentage;

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [this.percentage, this.left],
            backgroundColor: ['#02A844', '#A6ABBD'],
          },
        ],
      },
      options: {
        cutout: '60%',
        animation: {
          animateRotate: true,
          animateScale: true,
        },
        layout: {
          padding: {
            left: 5,
            bottom: 0,
          },
        },
        radius: '70%',
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          }
        }
      },
    });
  }
}


